/**************************************************************************************************/
/*   File: /src/app/shared/components/loader/loader.component.ts                                  */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Observable } from 'rxjs';

import { Component, Input, OnInit } from '@angular/core';

/**
 * The loader
 */
@Component({
  selector: 'nwpl-frnt-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  /**
   * The is loading boolean
   */
  @Input() isLoading: boolean;

  /**
   * The constructor
   */
  constructor() { }

  /**
   * The ng on init hook
   */
  ngOnInit() {
  }

}
